import { produce } from 'immer'
import type { State } from '../typings'
import type { LocationDTO } from '@sales-center/common'
import type { CoreEmployeeModel } from '@user/store/techs'
import type { ILeadOppProduct } from '@user/store/leadOppProducts'

export type InitApptAction = {
  type: 'initAppt'
  payload: {
    locations: LocationDTO[]
    techs: CoreEmployeeModel[]
    services: ILeadOppProduct[]
  }
}

export const initApptAction = produce<State, [InitApptAction['payload']]>(
  (draft, payload) => {
    if (draft.appointment) {
      const { techs, services, locations } = payload
      const { appointmentId, locationId, appointmentType, tech } =
        draft.appointment

      const location = locations.find((l) => l.externalLinkId === locationId)

      const branchId = location?.branchId ?? -1

      const techId = techs.find((t) => t.username === tech)?.techId ?? ''

      const serviceIds = services
        .filter((s) => {
          if (appointmentType === 'Estimate') {
            return s.estimateEntityId === appointmentId
          } else {
            return s.appointmentEntityId === appointmentId
          }
        })
        .map((s) => `${s.id}`)

      draft.branchId = branchId
      draft.appointmentTechId = techId
      if (locationId !== null) draft.externalSvcLocId = locationId

      draft.recurringServices = appointmentType === 'Initial'

      draft.bestFitInput.serviceIds = serviceIds
      draft.bestFitInput.appointmentId = `${appointmentId}`
    }
  },
)

export const initApptActionCreator = (
  payload: InitApptAction['payload'],
): InitApptAction => ({
  type: 'initAppt',
  payload,
})
